import { Alert } from '@side/pantry';
import { useClearPageBannerById } from 'src/state/navigation';

interface Props {
  interactionId: string;
}
export const MLSBannerId = 'MLS';

export const MLSBanner = ({ interactionId }: Props) => {
  const clearBanner = useClearPageBannerById(interactionId);

  const message =
    'This transaction was autofilled from the MLS. Please review all of the information to ensure it is complete and correct.';

  const handleClose = () => {
    clearBanner(MLSBannerId);
  };

  return (
    <Alert
      severity="primary"
      square
      aria-label="MLS Autofill Notice"
      onClose={handleClose}
    >
      {message}
    </Alert>
  );
};
